import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["clientUsername"];
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _URLSearchParams from "@babel/runtime-corejs3/core-js/url-search-params";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImportClientsModal from "./import-clients/import-clients-modal.vue";
import AddClientModal from "./add-client-modal";
import PageHeader from "@Shared/components/general/page-header";
import { mapActions, mapState, mapGetters } from "vuex";
import { LOAD_CLIENTS, LOAD_CLIENT_APPLICATIONS, COPY_APPLICATION } from "../store/applications-list-actions";
import { LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import { CLIENTS_LOADED, GET_CURRENT_FILTERS } from "../store/applications-list-getters";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import ApplicationsListTable from "./applications-list-table";
import ApplicationsListActions from "./applications-list-actions";
import ApplicationListLoader from "./application-list-loader";
import LoadMoreLoader from "./load-more-loader";
import Amplitude from "../../../../../../../../shared/utils/amplitude";
import TooltipsMixin from "@Shared/utils/shared-mixins/tooltips-mixin";
import { isEmpty } from "lodash";
import CopyApplicationModal from "./copy-application-modal";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationsListContainer",
  title() {
    return this.$t("sidebar.sections.applications");
  },
  components: {
    PageHeader,
    ImportClientsModal,
    AddClientModal,
    ApplicationsListTable,
    ApplicationsListActions,
    ApplicationListLoader,
    LoadMoreLoader,
    CopyApplicationModal
  },
  mixins: [TooltipsMixin],
  data() {
    return {
      modalData: {},
      loading: true,
      loadingClients: false,
      loadingTable: false,
      tableSelector: null,
      active: true,
      copyingApp: false,
      DEFAULT_LIMIT: 20,
      applicationId: "",
      clientUsername: "",
      clientData: {},
      applicationStreet: "",
      currentAddress: null,
      documentCount: 0
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails", "accountDetails"])), mapState("ApplicationsListStore", ["totalClients", "applicationCount", "clients", "currentAgent", "clientsTableFilters"])), mapGetters("ApplicationsListStore", [CLIENTS_LOADED, GET_CURRENT_FILTERS])), mapGetters("BoardStore", [BOARDS])), mapGetters("AgentStore", ["agents"])), {}, {
    currentClients() {
      return this.clients.byId;
    },
    isPropertyAccount() {
      return this.userDetails.username === this.currentAgent;
    },
    isBrokerAccount() {
      return this.accountDetails.accountType === "broker";
    },
    currentFilters() {
      const {
        board,
        read,
        status
      } = this.GET_CURRENT_FILTERS;
      const filters = [];
      if (board != null) {
        filters.push({
          text: board ? this.$t("application.listing.clientsOnBoard") : this.$t("application.listing.clientsNotOnBoard"),
          variation: "0",
          filter: "board"
        });
      }
      if (read != null) {
        filters.push({
          text: read ? this.$t("application.listing.oldClients") : this.$t("application.listing.newClients"),
          variation: "-30",
          filter: "read"
        });
      }
      if (status) filters.push({
        text: `${this.$options.filters.applicationStatus(status)} ${this.$tc("global.doorr.application", 2)}`,
        variation: "30",
        filter: "status"
      });
      return filters.length ? filters : null;
    },
    tableSummaryText() {
      if (this.totalClients) return this.$t("tables.filters.showingOutOfWithActual", {
        current: this.CLIENTS_LOADED,
        total: this.totalClients,
        actual: this.applicationCount
      });
      if (!this.currentClients && this.currentFilters) return this.$t("application.listing.filterClientsNoMatch");
      return this.$t("tables.messages.emptyApplication");
    },
    currentAddressObjLength() {
      return this.currentAddress ? _Object$keys(this.currentAddress).length : 0;
    }
  }),
  beforeDestroy() {
    this.destroy();
  },
  deactivated() {
    this.$nextTick(() => this.destroy());
  },
  activated() {
    this.init();
    this.handleScroll();
    this.resetChildRows();
    Amplitude.logEvent("Applications - visited");
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationsListStore", [LOAD_CLIENTS, LOAD_CLIENT_APPLICATIONS, COPY_APPLICATION])), mapActions("BoardStore", [LOAD_BOARDS])), {}, {
    destroy() {
      this.active = false;
      $("#page").off("scroll.application-infinite-scroll");
      this.destroyTooltips();
    },
    showImportModal() {
      this.$refs.importModal.$showModal();
    },
    resetChildRows() {
      if (this.$refs.applicationsTable && this.$refs.applicationsTable.closeOpenedRows) {
        this.$refs.applicationsTable.closeOpenedRows();
      }
    },
    async handleSort({
      orderBy,
      orderType
    }) {
      this.loadingTable = true;
      await this.LOAD_CLIENTS({
        agentUsername: this.currentAgent,
        limit: this.CLIENTS_LOADED,
        orderBy,
        orderType,
        partial: true
      });
      this.loadingTable = false;
      this.initTooltips();
      this.resetChildRows();
    },
    async searchClient(searchString) {
      this.loadingTable = true;
      Amplitude.logEvent("Applications - Search Input Changed", {
        data: {
          agentUsername: this.currentAgent
        },
        source: "input"
      });
      await this.LOAD_CLIENTS({
        agentUsername: this.currentAgent,
        searchString,
        partial: isEmpty(searchString)
      });
      this.loadingTable = false;
      this.initTooltips();
      this.resetChildRows();
    },
    showAddClientModal() {
      this.modalData = {
        requestPersonalDetails: true,
        agentUsername: this.currentAgent
      };
      this.$refs.addClientModal.show();
    },
    async init() {
      this.active = true;
      if (this.CLIENTS_LOADED) {
        this.loading = false;
      }
      if (isEmpty(this.agents.byId)) {
        this.resetData();
        const limit = this.DEFAULT_LIMIT;
        await _Promise.all([this.LOAD_BOARDS({
          agentUsername: this.currentAgent
        }), this.LOAD_CLIENTS({
          agentUsername: this.currentAgent || this.userDetails.username,
          limit,
          partial: true
        })]);
        this.loading = false;
        this.initTooltips();
        this.createApplicationOnInit();
        this.importDataOnInit();
        this.resetChildRows();
      }
    },
    onCreateApp(data) {
      this.modalData = _objectSpread(_objectSpread({}, data), {}, {
        agentUsername: this.currentAgent
      });
      this.$refs.addClientModal.show();
    },
    redirectToApplication(_ref) {
      let {
          clientUsername
        } = _ref,
        params = _objectWithoutProperties(_ref, _excluded);
      this.$router.push({
        name: "application",
        params: _objectSpread({
          clientUsername
        }, params)
      });
    },
    async copyApplication({
      copyAsCurrentAddress = null,
      copyAsPropertyOwned = null,
      copyAsPreviousAddress = null,
      copyDocuments = null
    }) {
      return await this.COPY_APPLICATION(_objectSpread(_objectSpread({
        data: {
          copyItems: ["all"],
          copyFromApplicationId: this.applicationId,
          copyAsCurrentAddress,
          copyAsPropertyOwned,
          copyAsPreviousAddress,
          copyDocuments
        }
      }, this.clientData), {}, {
        agentUsername: this.currentAgent
      }));
    },
    async onCopyApp(checkbox) {
      if (this.copyingApp) return;
      try {
        this.copyingApp = true;
        this.redirectToApplication(await this.copyApplication(checkbox));
        this.copyingApp = false;
      } catch (e) {
        this.copyingApp = false;
      }
    },
    openModal({
      clientUsername,
      clientDetails,
      modalData
    }) {
      this.applicationId = modalData.applicationId;
      this.applicationStreet = modalData.street;
      this.currentAddress = modalData.currentMainApplicantAddress;
      this.documentCount = modalData.documentCount;
      this.clientData = {
        clientUsername,
        clientDetails
      };
      if (!modalData.street && this.currentAddressObjLength <= 1 && modalData.documentCount == 0) {
        this.onCopyApp({
          copyAsCurrentAddress: false,
          copyAsPropertyOwned: false,
          copyAsPreviousAddress: false,
          copyDocuments: false
        });
        return;
      }
      showBModal("copy-application-modal", {}, this);
    },
    resetData() {
      this.modalData = {};
    },
    async filterAgent(agentUsername) {
      this.loadingTable = true;
      await _Promise.all([this.LOAD_CLIENTS({
        agentUsername,
        partial: true
      }), this.LOAD_BOARDS({
        agentUsername
      })]);
      this.loadingTable = false;
      this.initTooltips();
      this.resetChildRows();
    },
    handleScroll() {
      $("#page").on("scroll.application-infinite-scroll", event => {
        const scroller = $(event.currentTarget);
        if (scroller.scrollTop() + 200 + scroller.innerHeight() >= scroller[0].scrollHeight) {
          if (this.totalClients > this.CLIENTS_LOADED && !this.loadingClients) {
            this.loadMoreClients();
            Amplitude.logEvent("Applications - loading more clients due to scroll");
          }
        }
      });
    },
    async loadMoreClients() {
      this.loadingClients = true;
      await this.LOAD_CLIENTS({
        agentUsername: this.currentAgent,
        offset: this.CLIENTS_LOADED,
        partial: true
      });
      this.loadingClients = false;
      this.initTooltips();
      this.resetChildRows();
    },
    getTitle() {
      return this.isBrokerAccount ? this.$t("application.listing.showingApplications") : this.$t("application.listing.yourApplications");
    },
    createApplicationOnInit() {
      const addApplication = new _URLSearchParams(location.hash.split("?")[1]).get("addApplication");
      if (addApplication === "true") {
        this.$nextTick(() => {
          this.showAddClientModal();
        });
      }
    },
    importDataOnInit() {
      const importClients = new _URLSearchParams(location.hash.split("?")[1]).get("importClients");
      if (importClients === "true") {
        this.$nextTick(() => {
          this.showImportModal();
        });
      }
    },
    async handleFilter(data) {
      this.loadingTable = true;
      Amplitude.logEvent("Applications - Agent Filter Changed", {
        data: _objectSpread(_objectSpread({}, data), {}, {
          agentUsername: this.currentAgent
        }),
        source: "dropdown"
      });
      await this.LOAD_CLIENTS(_objectSpread({
        agentUsername: this.currentAgent,
        partial: true
      }, data));
      this.loadingTable = false;
      this.initTooltips();
      this.resetChildRows();
    },
    async clearFilter(data) {
      this.loadingTable = true;
      await this.LOAD_CLIENTS({
        agentUsername: this.currentAgent,
        partial: true,
        [data]: null
      });
      this.$refs.applicationActions.clearFilter(data);
      this.loadingTable = false;
      return;
    }
  })
});